if (typeof Cookiebot !== 'undefined' && !Cookiebot.hasResponse) {
    window.CookiebotCallback_OnAccept = () => {
        window.location.reload()
    }

    window.CookiebotCallback_OnDecline = () => {
        window.location.reload()
    }
}
